<template>
  <li :searchWord="searchWord" @click="search">{{searchWord}}</li>
</template>

<script>
export default {
  props: ['searchWord'],
  methods: {
    search: function(e) {
      this.$emit('searchThisItem', e.target.innerText);
    }
  }
}
</script>

<style scoped>
  li {
     display: inline-block;
     margin: 1.333vw;
     border-radius: 12px;
     background-color: rgba(237,237,237,1);
     padding: 4px 15px 3.5px 15px;
     font-size: 13px;
		 color: #333333;
  }
</style>
